import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { studyAnalysesActions } from 'features/studyAnalyses';

const useStudyAnalyses = () => {
  const dispatch = useDispatch();
  const getStudyAnalyses = useCallback(({ offset }) => dispatch(studyAnalysesActions.getStudyAnalyses({ offset })), [dispatch]);
  const getStudyAnalysis = useCallback(({ id, cable }) => dispatch(studyAnalysesActions.getStudyAnalysis({ id, cable })), [dispatch]);
  const createStudyAnalysis = useCallback(() => dispatch(studyAnalysesActions.createStudyAnalysis()), [dispatch]);
  const clearLocalStudyAnalyses = useCallback(() => dispatch(studyAnalysesActions.clearLocalStudyAnalyses()), [dispatch]);
  const clearLocalActiveStudyAnalysis = useCallback(() => dispatch(studyAnalysesActions.clearLocalActiveStudyAnalysis()), [dispatch]);

  return {
    getStudyAnalyses,
    getStudyAnalysis,
    createStudyAnalysis,
    clearLocalStudyAnalyses,
    clearLocalActiveStudyAnalysis
  };
};

export default useStudyAnalyses;